module.exports = __webpack_public_path__ + "static/media/banner_01.2d6f050f.png";